<template>
  <div
    class="hidden-scrollbar flex h-10 w-full items-center space-x-2 rounded-tr border-t border-r border-l border-gray-200 px-4 text-xs font-medium whitespace-nowrap"
  >
    <template
      v-for="(log, index) in historyLogs"
      :key="`breadcrumb-${log.started_at || log.issued_at}`"
    >
      <data-orchestration-history-breadcrumb
        :log="log"
        @click="handleBreadcrumbClick(log)"
      />
      <div v-if="index !== historyLogs.length - 1" class="min-w-fit">
        <icon-base :icon="IconArrowRight" />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useUnderwritingLogs } from "@/hooks/underwriting";

import DataOrchestrationHistoryBreadcrumb from "./DataOrchestrationHistoryBreadcrumb.vue";
import IconArrowRight from "@/components/icons/IconArrowRight.vue";

import type { IDataOrchestrationLogEntry } from "@/models/applications";

const { historyLogs } = useUnderwritingLogs();

const handleBreadcrumbClick = (log: IDataOrchestrationLogEntry) => {
  // DO Logs don't have ID on them so we rely on the timestamps
  // NOTE: started_at for automated logs, issued_at for manual actions
  const timestamp = log.started_at || log.issued_at;
  const elementId = `log-${timestamp}`;
  document
    .getElementById(elementId)
    ?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
};
</script>

<style scoped>
@reference "@/assets/tailwind.css";

.hidden-scrollbar::-webkit-scrollbar {
  display: none;
}

.hidden-scrollbar {
  overflow-x: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
